var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.96 13.71a.625.625 0 10-1.224.255.653.653 0 01-.133.547.635.635 0 01-.5.238H1.897a.635.635 0 01-.5-.238.653.653 0 01-.133-.547c.649-3.116 3.397-5.391 6.57-5.468a4.279 4.279 0 00.332 0 6.875 6.875 0 015.553 3.052.625.625 0 001.038-.696 8.13 8.13 0 00-4.212-3.201A4.246 4.246 0 0012.25 4.25 4.255 4.255 0 008 0a4.255 4.255 0 00-4.25 4.25c0 1.39.671 2.628 1.707 3.403A8.122 8.122 0 00.041 13.71 1.898 1.898 0 001.897 16h12.206a1.898 1.898 0 001.856-2.29zM5 4.25c0-1.654 1.346-3 3-3s3 1.346 3 3a3.004 3.004 0 01-2.848 2.996 8.164 8.164 0 00-.303 0A3.004 3.004 0 015 4.25z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthHeader);
export default __webpack_public_path__ + "static/media/auth-header.e78f421097892ce9500f0be9bd67760f.svg";
export { ForwardRef as ReactComponent };